// Mock data for KS Care - Dagbesteding & Logeeropvang

export const navigationLinks = [
  { name: 'Home', href: '/' },
  { name: 'Dagopvang', href: '/dagopvang' },
  { name: 'Logeeropvang', href: '/logeeropvang' },
  { name: 'FAQ', href: '/faq' },
  { name: 'Voor wie', href: '/voor-wie' }
];

export const features = [
  {
    id: 1,
    title: 'Kleinschalig & Huiselijk',
    description: 'Onze aanleunwoning biedt een warme, veilige en overzichtelijke omgeving waar jongeren zich thuis voelen. Met afwisseling tussen actieve en passieve momenten.'
  },
  {
    id: 2,
    title: 'Koken en Bakken',
    description: 'Samen gezonde en vooral lekkere maaltijden bereiden. Kinderen leren kookvaardigheden terwijl ze plezier maken.'
  },
  {
    id: 3,
    title: 'Uitjes & Uitstapjes',
    description: 'Zwemmen, dierentuin, pretpark, kermis, boerderij - afgestemd op de behoefte en interesses van het kind.'
  },
  {
    id: 4,
    title: 'Structuur & Voorspelbaarheid',
    description: 'Het programma is afhankelijk van de zorgvraag. Duidelijke structuur en een voorspelbare aanpak zorgen voor rust en veiligheid.'
  }
];

export const careTypes = [
  {
    id: 1,
    title: 'Lichamelijke beperking',
    image: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/d5smgjlo_6fef87f4-871e-4f40-b99f-d054361c4019%20%281%29.jpeg',
    description: 'Begeleiding en ondersteuning voor jongeren met een lichamelijke beperking, met aandacht voor persoonlijke verzorging en mobiliteit.',
    ageRange: '3-18 jaar',
    details: 'Dagopvang & Logeren',
    color: 'rgba(180, 220, 230, 0.3)',
    buttonColor: '#5DADE2'
  },
  {
    id: 2,
    title: 'ASS',
    image: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/pnrsriag_IMG_8163%20%282%29.jpeg',
    description: 'Gespecialiseerde begeleiding voor jongeren met autisme spectrum stoornis, met focus op structuur en voorspelbaarheid.',
    ageRange: '3-18 jaar',
    details: 'Dagopvang & Logeren',
    color: 'rgba(255, 220, 180, 0.3)',
    buttonColor: '#F39C12'
  },
  {
    id: 3,
    title: 'ADHD',
    image: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/7x7q2891_3982ab8c-ed41-46b3-8787-1ce02cc8dd1f%20%281%29.jpeg',
    description: 'Intensieve 1-op-1 begeleiding voor jongeren met ADHD, gericht op rust, focus en emotieregulatie.',
    ageRange: '3-18 jaar',
    details: 'Dagopvang & Logeren',
    color: 'rgba(180, 230, 200, 0.3)',
    buttonColor: '#52BE80'
  },
  {
    id: 4,
    title: 'Gedragsproblematiek',
    image: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/nvyhz5hb_IMG_2033%20%281%29.jpeg',
    description: 'Deskundige begeleiding bij (lichte) gedragsproblematiek met expertise in moeilijk verstaanbaar gedrag.',
    ageRange: '3-18 jaar',
    details: 'Dagopvang & Logeren',
    color: 'rgba(255, 200, 180, 0.3)',
    buttonColor: '#FF8B6B'
  }
];

export const newsArticles = [
  {
    id: 1,
    title: 'Structuur en voorspelbaarheid bij ASS',
    category: 'Begeleiding',
    image: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/muij7d9r_Image.jpeg',
    excerpt: 'Hoe wij met structuur en duidelijkheid zorgen voor rust en veiligheid bij kinderen met autisme.',
    link: '/blog/structuur-bij-ass'
  },
  {
    id: 2,
    title: 'Het belang van respijtzorg voor ouders',
    category: 'Zorg',
    image: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/7x7q2891_3982ab8c-ed41-46b3-8787-1ce02cc8dd1f%20%281%29.jpeg',
    excerpt: 'Ontdek waarom tijdelijke ontlasting essentieel is voor het welzijn van het hele gezin.',
    link: '/blog/respijtzorg'
  },
  {
    id: 3,
    title: '1-op-1 begeleiding: waarom het verschil maakt',
    category: 'Methodiek',
    image: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/d5smgjlo_6fef87f4-871e-4f40-b99f-d054361c4019%20%281%29.jpeg',
    excerpt: 'De voordelen van intensieve persoonlijke begeleiding voor jongeren met extra ondersteuningsbehoeften.',
    link: '/blog/een-op-een-begeleiding'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Ouder van Tim (12 jaar)',
    videoUrl: 'https://www.youtube.com/watch?v=SXNboPPEQKI',
    thumbnail: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/d5smgjlo_6fef87f4-871e-4f40-b99f-d054361c4019%20%281%29.jpeg',
    quote: 'Eindelijk rust en structuur voor onze zoon'
  },
  {
    id: 2,
    name: 'Moeder van Lisa (9 jaar)',
    videoUrl: 'https://www.youtube.com/watch?v=SXNboPPEQKI',
    thumbnail: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/7x7q2891_3982ab8c-ed41-46b3-8787-1ce02cc8dd1f%20%281%29.jpeg',
    quote: 'Professionele zorg in een huiselijke sfeer'
  },
  {
    id: 3,
    name: 'Familie van Sven (15 jaar)',
    videoUrl: 'https://www.youtube.com/watch?v=SXNboPPEQKI',
    thumbnail: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/nvyhz5hb_IMG_2033%20%281%29.jpeg',
    quote: 'Betrouwbare respijtzorg waar we op kunnen bouwen'
  },
  {
    id: 4,
    name: 'Ouders van Emma (7 jaar)',
    videoUrl: 'https://www.youtube.com/watch?v=SXNboPPEQKI',
    thumbnail: 'https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/pnrsriag_IMG_8163%20%282%29.jpeg',
    quote: 'Persoonlijke aandacht die het verschil maakt'
  }
];

export const contactInfo = {
  location: 'Delweide 34',
  address: '6118 AH Nieuwstadt',
  phone: '06-19199023',
  email: 'info@kscare.nl'
};

export const quickActions = [
  {
    id: 1,
    title: 'Vragen?',
    subtitle: 'Mail ons',
    link: 'mailto:info@kscare.nl?subject=Vraag%20over%20KS%20Care',
    icon: 'help-circle'
  },
  {
    id: 2,
    title: 'Kom kennismaken!',
    subtitle: 'Mail voor een afspraak',
    link: 'mailto:info@kscare.nl?subject=Kennismaking%20aanvraag',
    icon: 'calendar'
  },
  {
    id: 3,
    title: 'Aanmelden?',
    subtitle: 'Mail ons',
    link: 'mailto:info@kscare.nl?subject=Aanmelding%20KS%20Care',
    icon: 'user-plus'
  }
];